import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

type FlyoutContextValue = {
    onClose: () => void;
};

type FlyoutContextProviderProps = {
    onClose: () => void;
    children: ReactNode;
};

export const FlyoutContext = createContext<FlyoutContextValue | undefined>(
    undefined
);
FlyoutContext.displayName = "FlyoutContext";

export const FlyoutContextProvider = ({
    children,
    ...props
}: FlyoutContextProviderProps) => {
    return <FlyoutContext value={props}>{children}</FlyoutContext>;
};

export const useFlyoutContext = () => {
    const context = use<FlyoutContextValue | undefined>(FlyoutContext);

    if (!isDefined(context)) {
        throw new Error(`${FlyoutContext.displayName} is undefined.`);
    }

    return context;
};
